import script from "./FeesEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FeesEdit.vue?vue&type=script&setup=true&lang=js"

import "./FeesEdit.vue?vue&type=style&index=0&id=55ce39ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ce39ee"]])

export default __exports__